import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferAddToCart} from "./offer/hit_gtm_offer_add_to_cart";
import {hitGTMPropertyAddToCart} from "./property/hit_gtm_property_add_to_cart";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceAddToCart = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string
) => {
    const propertyData = (data.property && data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyAddToCart(data, viewType, leadType, sourceSection);
    }

    return hitGTMOfferAddToCart(data, viewType, leadType, sourceSection);
};
import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferAddToCart} from "./offer/hit_gtm_offer_add_to_cart";
import {hitGTMPropertyAddToCart} from "./property/hit_gtm_property_add_to_cart";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceAddToCart = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string
) => {
    const propertyData = (data.property && data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyAddToCart(data, viewType, leadType, sourceSection);
    }

    return hitGTMOfferAddToCart(data, viewType, leadType, sourceSection);
};
